import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Amber-icon move/bound notice shared by the bind dialog (§9.1) and the
 * wizard `bind-number` step (§12.2) — one pattern, one copy stem (H3). The
 * ICON carries the color; body text stays default (design B1: never color-
 * alone, never amber body). `yellow-500` is the app's existing warning token
 * (`Toast.tsx:28`, `badge.tsx:17`) — no new colors (P1 §4).
 */
export function BoundAgentNotice({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-start gap-2 text-sm">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-yellow-500" aria-hidden="true" />
      <p className="text-sm">{children}</p>
    </div>
  );
}
